import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=91cf4f6c&"
import script from "./adminList.vue?vue&type=script&lang=ts&"
export * from "./adminList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "adminList.vue"
export default component.exports